<app-solutions-header-banner></app-solutions-header-banner>

<div class="container w-full mx-auto my-10 px-10 flex flex-col gap-5 md:gap-3 justify-center items-center mt-20">
  <h2 class="font-bold text-3xl website-heading">Transport Logistics & Supply Chain</h2>
  <span class="font-light text-2xl website-light-heading">Tracking, Managing and Optimizing your Workflow</span>

  <span class="text-l text-justify w-full mt-5 color-[#0A0A0A]">Telematics software is rapidly emerging as a must-have
    in fleet management, delivering proven advantages in security, fuel optimization, and vehicle health maintenance.
    Our advanced web solution combined with key Telematics Devices, offers comprehensive visibility to efficiently
    manage fleets of varying sizes and types.</span>

  <!-- Row 1 -->
  <div class="flex gap-6 md:flex-row flex-col mt-5 w-full">
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_LOCATION_TRACK" alt="Vehicle and Machinery Location Tracking Icon" class="size-8">
      <span><strong>Location Tracking:</strong> Track your machinery or vehicle.</span>
    </div>
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_ZOOM" alt="Detention Time Monitoring Icon for Vehicle Tracking" class="size-8">
      <span><strong>Detention Time Monitoring:</strong> Tracks how long the vehicles wait at the start and end
        location.</span>
    </div>
  </div>

  <!-- Row 2 -->
  <div class="flex gap-6 md:flex-row flex-col mt-5 w-full">
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_PARKING_HUB" alt="Parking Hub Tracking Icon" class="size-8">
      <span><strong>Parking Hub:</strong> Locate vehicles in predefined parking spots and track their parking
        duration.</span>
    </div>
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_SAFETY" alt="Safety Index Score Icon" class="size-8">
      <span><strong>Safety Index:</strong> Score based on various safety parameters.</span>
    </div>
  </div>

  <!-- Row 3 -->
  <div class="flex gap-6 md:flex-row flex-col mt-5 w-full">
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_GEOFENCE" alt="Multi-Geofence Setup Icon for Vehicle Tracking" class="size-8">
      <span><strong>Set Multiple Geofence:</strong> Create multiple virtual boundaries on a map and receive
        notifications when a vehicle
        enters or leaves these set boundaries.</span>
    </div>
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_ANALYTICS" alt="Analytics Dashboard for Driving Metrics and Fuel Efficiency" class="size-8">
      <span><strong>Analytics Index:</strong> Generate reports on different driving metrics like distance, fuel
        efficiency, and route
        optimization.</span>
    </div>
  </div>

  <div class="flex flex-col mt-10 gap-10  md:mt-20 md:gap-20 items-center justify-center">
    <img [src]="Images.SOLUTION_TLS_BANNER" alt="Varroc Connect Transport, Logistics & Supply Chain Solutions" class="w-1/2">
  </div>

</div>